import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { DefaultHeaderCell, NonSortableHeaderCell } from "../../../Layout/SortedList";

class ProductsListHeader extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    sort: PropTypes.object
  };

  static defaultProps = {
    isMobile: false,
    sort: {}
  };

  handleClick = keyName => this.props.onClick(keyName);

  render() {
    return (
      <div role="row" tabIndex="0" className="sorted-list__row-header">
        <DefaultHeaderCell
          className="--first --x4"
          keyName="customerPO"
          label={i18n.t("billsOfLading.PO")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x6"
          keyName="productName"
          label={i18n.t("billsOfLading.productName")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--x4"
          keyName="dimension"
          label={i18n.t("billsOfLading.dimension")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--right --x2"
          keyName="quantityShipped.value"
          label={i18n.t("billsOfLading.quantityShipped")}
          tooltipContent={i18n.t("tooltip.shipped")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        <DefaultHeaderCell
          className="--center --x2"
          keyName="numberOfRolls"
          label={i18n.t("billsOfLading.rolls")}
          sortedColumn={this.props.sort.keyName}
          sortDirection={this.props.sort.direction}
          onClick={this.handleClick}
        />
        {!this.props.isMobile && <NonSortableHeaderCell className="--x2" keyName="marks" label={i18n.t("billsOfLading.marks")} />}
      </div>
    );
  }
}

export default ProductsListHeader;



// WEBPACK FOOTER //
// ./src/components/BillOfLading/List/Products/ProductsListHeader.js